import { Link } from 'react-router-dom';
import { Leaf } from 'lucide-react';
import AppIcon from './AppIcon';
import { useCookieConsent } from '../context/CookieConsentContext';
import { legalNavLinks } from '../data/legalDocuments';

export default function Footer() {
  const { openPreferences } = useCookieConsent();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="logo-icon">
            <AppIcon icon={Leaf} size={32} />
          </span>
          <span>HealthShopLongevity</span>
          <p className="footer-tagline">
            Balıkesir Güven Özel Sağlık Laboratuvar Hizmetleri Ltd. Şti.
          </p>
        </div>

        <div className="footer-links">
          <h4>Hızlı Linkler</h4>
          <Link to="/">Ana Sayfa</Link>
          <Link to="/shop">Ürünler</Link>
          <Link to="/cart">Sepet</Link>
        </div>

        <div className="footer-links">
          <h4>Yasal</h4>
          {legalNavLinks.map((link) => (
            <Link key={link.slug} to={link.path}>
              {link.title}
            </Link>
          ))}
          <Link to="/cerez-politikasi">Çerez Politikası</Link>
          <button type="button" className="footer-link-btn" onClick={openPreferences}>
            Çerez Tercihleri
          </button>
        </div>

        <div className="footer-links">
          <h4>Hesap</h4>
          <Link to="/login">Giriş Yap</Link>
          <Link to="/register">Kayıt Ol</Link>
          <Link to="/orders">Siparişlerim</Link>
          <Link to="/profile">Profilim</Link>
          <Link to="/addresses">Adreslerim</Link>
        </div>

        <div className="footer-links">
          <h4>İletişim</h4>
          <a href="tel:+905535382462">+90 553 538 24 62</a>
          <a href="mailto:info@irgilakademi.com">info@irgilakademi.com</a>
          <span>Bahçelievler Mah. Atatürk Cad. No: 10B, Altıeylül/Balıkesir</span>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© 2026 HealthShopLongevity. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
}
